interface TwitterProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Twitter = ({ className = '', ...props }: TwitterProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_1574_86)">
        <path
          d="M13.5237 10.7746L19.4811 3.99896H18.0699L12.8949 9.88097L8.7648 3.99896H4L10.2469 12.8945L4 19.9989H5.4112L10.8725 13.786L15.2352 19.9989H20M5.92053 5.04022H8.08853L18.0688 19.0088H15.9003"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1574_86">
          <rect width="16" height="16" fill="currentColor" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Twitter;
